import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuItem } from '../../../core/enums/menu.enum';
import { MenuService } from '../../../core/services/menu.service';

interface BreadCrumb {
	label: MenuItem;
	url: string;
	noLink?: boolean;
}

@Component({
	selector: 'cfe-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
	breadcrumbsData: BreadCrumb[];

	private routerSubscription: Subscription;

	constructor(private activatedRoute: ActivatedRoute, private router: Router, protected menuService: MenuService) {}

	ngOnInit() {
		this.breadcrumbsData = this.buildBreadCrumb(this.activatedRoute.snapshot);
		this.routerSubscription = this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.breadcrumbsData = this.buildBreadCrumb(this.router.routerState.snapshot.root);
			}
		});
	}

	ngOnDestroy() {
		this.routerSubscription.unsubscribe();
	}

	/**
	 * Creates a bread crumb item for every route child
	 *
	 * @param route
	 * @param url
	 * @param breadcrumbs
	 * @returns
	 */
	buildBreadCrumb(route: ActivatedRouteSnapshot, url: string = '', breadcrumbs: Array<BreadCrumb> = []): Array<BreadCrumb> {
		if (route.routeConfig && route.routeConfig.data && route.routeConfig.data['breadcrumb']) {
			// In the routeConfig the complete path is not available, so we rebuild it each time
			const newPath = route.routeConfig.data['breadcrumbUrlPath'] ? route.routeConfig.data['breadcrumbUrlPath'] : route.routeConfig.path;
			url = url + '/' + newPath;

			const breadcrumb = {
				label: route.routeConfig.data['breadcrumb'],
				url,
				noLink: !route.routeConfig.data['breadcrumbHideLink']
			};

			breadcrumbs.push(breadcrumb);
		}

		// If we are not on our current path yet, there will be more children to look after
		if (route.firstChild) {
			return this.buildBreadCrumb(route.firstChild, url, breadcrumbs);
		}

		return breadcrumbs;
	}

	translateMenu(menuItem: MenuItem) {
		return this.menuService.getByMenuItem(menuItem);
	}
}
